import DownloadMultipleSettingsContainer from './containers/DownloadMultipleSettingsContainer'

export default DownloadMultipleSettingsContainer
